<template>
  <div class="form-group boolean rwc_program_consent">
    <div class="checkbox">
      <label
        class="program-consent-label"
        for="rugby-program-consent-checkbox"
      >
        <input
          id="rugby-program-consent-checkbox"
          v-model="acceptedRwcProgramConsent"
          class="rugby-program-consent-checkbox"
          type="checkbox"
          name="rwc_program_consent_checkbox"
          @change="updateRwcProgramConsent"
        >
        <span class="custom-checkbox" />
        <div class="program-consent-text-wrapper">
          <!-- eslint-disable vue/no-v-html -->
          <span
            class="program-consent-text"
            v-html="$t('creditCardForm.rwcPartnerProgramConsent')"
          />
          <!-- eslint-enable -->
        </div>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProgramConsentCheckbox',
  emits: ['update-rugby-program-consent'],
  data() {
    return {
      acceptedRwcProgramConsent: false
    }
  },
  methods: {
    updateRwcProgramConsent() {
      this.$emit('update-rugby-program-consent', this.acceptedRwcProgramConsent)
    }
  },
}

</script>